import "babel-polyfill";
import "event-source-polyfill";
import "@/plugins/vuetify";
import Vue from "vue";
import VueLodash from 'vue-lodash'
// import lodash from 'lodash';
import App from "@/App.vue";
import i18n from "@/i18n";
import { store } from "@/store";
import { router, helpersMixin } from "@/utils";
import { init } from 'emailjs-com';
import MultiFiltersPlugin from "./plugins/multifilters";
import cssVars from 'css-vars-ponyfill';
import 'swiper/css/swiper.css'

// Filters available globally
Vue.filter("currency", value => `$${parseFloat(value).toFixed(2)}`);

// emailjs init 
init("user_dd5GwksaHIw7bHElkGyq7");

// Plugins installed
Vue.use(VueLodash, { name: '$lodash' })
// Vue.use(lodash, { name: '$lodash' })
Vue.use(require("vue-moment"));
Vue.use(MultiFiltersPlugin);
Vue.mixin(helpersMixin);

Vue.config.productionTip = false;

/**
* @instance VUE Framework
*/
const vueApp = new Vue({
  store,
  i18n,
  render: h => h(App),
  router,
});

cssVars({
  // Targets
  rootElement: document,
  shadowDOM: false,

  // Sources
  include: 'link[rel=stylesheet],style',
  exclude: '',
  variables: {},

  // Options
  onlyLegacy: true,
  preserveStatic: true,
  preserveVars: false,
  silent: false,
  updateDOM: true,
  updateURLs: true,
  watch: false
});

router.onReady(() => {
  console.log('Router is ready');
  vueApp.$mount('#app');
}, () => {
  console.log('Router has error');
});